module.exports = __webpack_public_path__ + "assets/media/lunch.57abd0f4.mp3";